<div mat-dialog-title class="form-header d-flex px-3">
  <h5 class="modal-title">Ajouter un nouveau ticket 1</h5>
  <button type="button" class="editButton ml-auto" (click)="closedialog()">
    &times;
  </button>
</div>
<mat-dialog-content class="minHeight">
  <form
    class="section work-experience"
    [formGroup]="newTicket"
    *ngIf="!hasExistingTicket"
  >
    <div class="row">
      <div class="col-md-12 mx-auto">
        <div class="work-section">
          <!-- ticket type  -->
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="title"
                  >Type du ticket
                  <span class="text-danger">*</span>
                </label>

                <ng-select
                  formControlName="ticketType"
                  name="ticketType"
                  placeholder="Choisir le type"
                  [items]="ticketType"
                  (change)="selectingTicketType($event)"
                  bindLabel="name"
                  bindValue="num"
                >
                  <ng-template
                    ng-option-tmp
                    let-item="item"
                    let-index="index"
                    let-search="searchTerm"
                  >
                    <div class="d-flex justify-content-between my-auto">
                      <h6 class="mb-0" [ngOptionHighlight]="search">
                        {{ item.name }}
                      </h6>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <!-- STANDARD -->
          <div class="row" *ngIf="p?.ticketType?.value == 1">
            <div class="col-md-12 mx-auto">
              <div class="work-section">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="title"
                        >Titre
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        name="title"
                        [ngClass]="{
                          'is-invalid': submittedTicket && p.title.errors
                        }"
                        formControlName="title"
                        type="text"
                        class="form-control"
                        id="title"
                      />
                      <small
                        class="text-danger"
                        *ngIf="submittedTicket && p.title.hasError('required')"
                      >
                        Ce champ est obligatoire.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="description"
                        >Description <span class="text-danger">*</span>
                      </label>
                      <textarea
                        name="description"
                        [ngClass]="{
                          'is-invalid': submittedTicket && p.description.errors
                        }"
                        formControlName="description"
                        type="text"
                        class="form-control"
                        id="description"
                      ></textarea>
                      <small
                        class="text-danger"
                        *ngIf="
                          submittedTicket && p.description.hasError('required')
                        "
                      >
                        Ce champ est obligatoire.
                      </small>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="service"
                            >Service <span class="text-danger">*</span>
                          </label>
                          <select
                            name="service"
                            [ngClass]="{
                              'is-invalid': submittedTicket && p.service.errors
                            }"
                            formControlName="service"
                            class="form-control"
                            id="service"
                          >
                            <option value="">...</option>
                            <option value="Service Commercial">
                              Service Commercial
                            </option>
                            <option value="Service Technique">
                              Service Technique
                            </option>
                          </select>
                          <small
                            class="text-danger"
                            *ngIf="
                              submittedTicket && p.service.hasError('required')
                            "
                          >
                            Ce champ est obligatoire.
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Amount to be changed  -->
          <div class="row" *ngIf="p?.ticketType?.value == 2">
            <div class="col-md-12">
              <div class="form-group">
                <label for="title"
                  >Prix
                  <span class="text-danger">*</span>
                </label>
                <input
                  pattern="^[0-9]{1,4}(\.[0-9]{1,3})?$"
                  name="newAmount"
                  [ngClass]="{
                    'is-invalid': submittedTicket && p.newAmount.errors
                  }"
                  formControlName="newAmount"
                  type="text"
                  class="form-control"
                  id="newAmount"
                />
                <small
                  class="text-danger"
                  *ngIf="submittedTicket && p.newAmount.hasError('required')"
                >
                  Ce champ est obligatoire.
                </small>
                <small
                  class="text-danger"
                  *ngIf="submittedTicket && p.newAmount.hasError('pattern')"
                >
                  Veuillez vérifier le format du montant saisie en dinar
                  tunisien.
                </small>
              </div>
            </div>
          </div>
          <!-- change address -->
          <div *ngIf="p?.ticketType?.value == 3">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="newAddress">Adresse
                    <span class="text-danger">*</span>
                  </label>
                  <input name="newAddress" [ngClass]="{
                      'is-invalid': submittedTicket && p.newAddress.errors
                    }" formControlName="newAddress" type="text" class="form-control" id="newAddress"
                    placeholder="Entrez l'adresse complète" />
                  <small class="text-danger" *ngIf="submittedTicket && p.newAddress.hasError('required')">
                    Ce champ est obligatoire.
                  </small>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- City Selection -->
              <div class="col-6">
                <div class="form-group">
                  <label for="citySelect">Gouvernorat <span class="text-danger">*</span></label>
                  <select class="form-control" [ngClass]="{
                      'is-invalid': submittedTicket && p.newCity.errors
                    }" (change)="onCityChange($any($event.target).value)" formControlName="newCity">
                    <option value="">Sélectionnez un gouvernorat</option>
                    <option [value]="city.name" *ngFor="let city of cities">
                      {{ city.name }}
                    </option>
                  </select>
                  <small class="text-danger" *ngIf="submittedTicket && p.newCity.hasError('required')">
                    Ce champ est obligatoire.
                  </small>
                </div>
              </div>

              <!-- District/Neighborhood Autocomplete -->
              <div class="col-6">
                <div class="form-group">
                  <label for="districtInput">Délégation / Localité <span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    [ngClass]="{ 'is-invalid': submittedTicket && p.newSubDivision.errors }"
                    formControlName="newSubDivision"
                    placeholder="Tapez pour rechercher un district ou quartier"
                    [disabled]="!selectedCity"
                    (input)="searchAddresses($any($event.target).value)"
                    (blur)="onAddressBlur($event)"
                    autocomplete="off"
                  />

                  <!-- Custom dropdown for address suggestions -->
                  <div
                    class="address-suggestions-dropdown"
                    *ngIf="addressSearchResults.length > 0 && showAddressSuggestions"
                    style="position: absolute; z-index: 1000; background: white; border: 1px solid #ccc; border-top: none; max-height: 200px; overflow-y: auto; width: 100%;">
                    <div
                      *ngFor="let address of addressSearchResults"
                      class="suggestion-item p-2"
                      style="cursor: pointer; border-bottom: 1px solid #eee;"
                      (mouseenter)="$event.target.style.backgroundColor='#f5f5f5'"
                      (mouseleave)="$event.target.style.backgroundColor='white'"
                      (mousedown)="selectAddress(address)"
                      (click)="$event.preventDefault()">
                      {{ address.displayName }}
                    </div>
                  </div>

                  <small class="text-info" *ngIf="selectedCity && !p.newSubDivision.value">
                    Commencez à taper pour voir les suggestions de districts et quartiers
                  </small>
                  <small class="text-danger" *ngIf="submittedTicket && p.newSubDivision.hasError('required')">
                    Ce champ est obligatoire.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- change TEL -->
          <div class="row" *ngIf="p?.ticketType?.value == 4">
            <div class="col-md-12">
              <div class="form-group">
                <label for="title"
                  >Numéro de téléphone
                  <span class="text-danger">*</span>
                </label>
                <input
                  name="newPhone"
                  [ngClass]="{
                    'is-invalid': submittedTicket && p.newPhone.errors
                  }"
                  formControlName="newPhone"
                  type="number"
                  class="form-control"
                  id="newPhone"
                />
                <small
                  class="text-danger"
                  *ngIf="submittedTicket && p.newPhone.hasError('required')"
                >
                  Ce champ est obligatoire.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex">
  <div class="ml-auto">
    <button type="button" class="btn btn-secondary" (click)="closedialog()">
      Fermer
    </button>
    <button type="submit" (click)="addTicket()" class="btn btn-primary ml-2">
      Ajouter
    </button>
  </div>
</div>
